/** Layout classes the authoring forms share (docs/ui-primitives.md: one name per repeated pattern). */

/** A row of small controls that wraps: a selector's options, a parameter. */
export const CONTROL_ROW_CLASS = "flex flex-wrap items-center gap-2 text-xs";

/** A row of controls at body text size. */
export const CONTROL_ROW_TEXT_CLASS = "flex flex-wrap items-center gap-2 text-sm";

/** Options that belong to the choice above them, indented by a rule. */
export const NESTED_OPTIONS_CLASS = "flex flex-wrap items-center gap-3 border-l-2 pl-3 text-xs";

/** A wider row of small controls: an input slot's kinds and flags. */
export const WIDE_CONTROL_ROW_CLASS = "flex flex-wrap items-center gap-3 text-xs";
